export default "__VITE_ASSET__Cb1tR8bZ__"